<template>
  <div>
    <modal-form v-model="show" :submit="submit" size="lg">
      <template v-slot:title> {{ ID ? "Editar" : "Novo" }} Template </template>
      <template v-slot:body>
        <v-row v-if="model.id">
          <v-col cols="6">
            <input-text label="ID" v-model="model.id" :disabled="true" />
          </v-col>
          <v-col cols="6">
            <input-text label="Titulo" v-model="model.description" required />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <input-text label="Titulo" v-model="model.description" required />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <input-select
              label="Produto de Origem"
              single
              v-model="model.productOrigin"
              :options="getProductOrigin"
              required
            />
          </v-col>
          <v-col cols="6">
            <input-select
              label="SMTP"
              v-model="model.smtp"
              :options="getSMTP"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <input-text
              label="Sobrescrever remetente"
              v-model="model.overrideSenderWith"
            />
          </v-col>
          <v-col cols="6">
            <input-text
              label="Sobrescrever resposta"
              v-model="model.overrideReplyToWith"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-toolbar flat dense color="grey lighten-3">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn @click="indent" color="black" v-on="on" icon
                    ><v-icon>mdi-format-indent-increase</v-icon></v-btn
                  >
                </template>
                <span>Indentar</span>
              </v-tooltip>
            </v-toolbar>
            <input-codeeditor
              ref="ce"
              v-model="model.htmlBody"
              mode="text/html"
            ></input-codeeditor>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <input-combobox
              label="Atributos substituíveis"
              placeholder="Digite..."
              v-model="model.attributesToReplace"
              small-chips
              multiple
              dense
              deletable-chips
              outlined
            >
            </input-combobox>
          </v-col>
        </v-row>
      </template>
    </modal-form>
  </div>
</template>

<script>
import 'codemirror/theme/base16-light.css';
export default {
  components: {},
  data () {
    return {
      show: false,
      model: {},
      ID: '',
      getSMTP: [],
      getProductOrigin: [
        { value: 'BMPDigital', text: 'BMPDigital' },
        { value: 'DBS', text: 'DBS' },
        { value: 'Safe', text: 'Safe' },
      ],
    };
  },
  methods: {
    openModal (sender) {
      const th = this;
      th.show = true;
      th.model = {};
      if (sender) {
        th.model = sender;
        th.ID = th.model.id;
      } else th.ID = '';
    },
    loadSMTP () {
      const th = this;
      const dto = { Search: '' };

      th.$api.EmailSMTP.Get(`GetAll?${dto}`).then(function (data) {
        if (Array.isArray(data)) {
          th.getSMTP = data.map((p) => {
            return { value: p, text: `${p.host} - ${p.account}` };
          });
        }
      });
    },
    submit () {
      const th = this;
      th.$api.EmailTemplate.Persist(th.model, th.model.id ? 'id' : '').then(
        function (response) {
          if (th.$api.UI.PostAction(response)) {
            th.show = false;
            th.$emit('close', !response.error);
          }
        }
      );
    },
    indent () {
      if (this.$refs && this.$refs.ce) {
        this.$refs.ce.indent();
      } else {
        setTimeout(() => this.indent(), 100);
      }
    },
    changeTheme () {
      if (this.$refs && this.$refs.ce) {
        this.$refs.ce.cmOption.theme = 'base16-light';
      } else {
        setTimeout(() => this.changeTheme(), 100);
      }
    },
  },
  mounted () {
    this.changeTheme();
  },
  beforeMount () {
    this.loadSMTP();
  },
};
</script>
